import * as moment from 'moment'
import 'fullcalendar'

export default class Calendar {
  constructor() {
    this.calendar = $('#calendar')
    this.singleDay = $('#single-day')
    this.listView = $('#list-view')
    this.eventResults = $('#event-results')

    this.selectedDate

    this.category = ''
    this.eventQuery = ''

    this.initCalendar()

    this.viewToggle = $('.event-views__button')

    this.viewToggle.on('click', (e) => {
      const target = $(e.currentTarget || e.target)
      this.viewChange(target)
    })

    $('#categories').on('change', (e) => {
      const selectedCategory = $(e.currentTarget || e.target).val()
      this.showLoadingSpinners()

      this.category = selectedCategory ? selectedCategory : ''

      if (this.eventQuery) {
        this.showResults()
      } else {
        this.calendar.next().fadeIn(100)

        this.calendar.find('.fc-day-number').removeClass('active')
        this.calendar.find('.fc-day-top').removeClass('fc-has-event')

        this.calendar.fullCalendar('removeEventSources')
        this.calendar.fullCalendar(
          'addEventSource',
          `/calendar.json?category=${this.category}`,
        )
      }
    })

    $('#event-query').on('change', (e) => {
      this.eventQuery = $(e.currentTarget || e.target).val()
    })

    $('#event-search').on('submit', (e) => {
      e.preventDefault()

      this.showResults()
      this.showLoadingSpinners()
    })
  }

  initCalendar() {
    this.calendar.fullCalendar({
      events: `/calendar.json?category=${this.category}&query=`,
      header: {
        left: '',
        center: 'prev,title,next',
        right: '',
      },
      views: {
        list: {
          duration: {
            months: 1,
          },
        },
        results: {
          type: 'list',
          duration: {
            days: 0,
          },
        },
      },
      dayNamesShort: ['S', 'M', 'T', 'W', 'TH', 'F', 'S'],
      height: 'auto',
      fixedWeekCount: false,
      showNonCurrentDates: false,
      viewRender: (view) => {
        let formattedTitle = $('.fc-center h2').text().split(' ')
        formattedTitle = `${formattedTitle[0]}<span>${formattedTitle[1]}</span>`
        $('.fc-center h2').html(formattedTitle)
      },
      eventAfterRender: (e, element) => {
        if (element.parent().parent().index() === 0) {
          const index = element.parent().index()
          element
            .closest('.fc-week')
            .find('.fc-content-skeleton thead td')
            .eq(index)
            .addClass('fc-has-event')
        }

        $('.fc-icon-left-single-arrow').attr('aria-label', 'previous month')
        $('.fc-prev-button').attr('aria-label', 'previous month')
        $('.fc-icon-right-single-arrow').attr('aria-label', 'next month')
        $('.fc-next-button').attr('aria-label', 'next month')
      },
      eventAfterAllRender: (view) => {
        const sources = this.calendar.fullCalendar('getEventSources')

        $('.fc-state-highlight').children('.fc-day-number').addClass('active')

        if (!this.selectedDate) {
          $('.fc-today').find('.fc-day-number').addClass('active')
        } else {
          const dateString = moment(this.selectedDate).format('YYYY-MM-DD')
          $('.fc-day-top[data-date="' + dateString + '"]')
            .find('.fc-day-number')
            .addClass('active')
        }

        if (!this.selectedDate) {
          this.selectedDate = this.calendar.fullCalendar('getDate')
          this.singleDay.next().fadeIn(100)
        }

        $('.fc-day-number').on('click', (e) => {
          this.calendar.find('.fc-day-number').removeClass('active')
          $(e.currentTarget || e.target).addClass('active')
        })

        if (sources.length > 0) {
          if (view.type === 'month') {
            $.ajax({
              url: `/calendar/day_events.js?category=${this.category}`,
              data: {
                day: this.selectedDate.format(),
              },
              success: () => {
                this.singleDay.next().fadeOut(300)
              },
            })
          } else {
            this.listView.next().fadeIn(100)

            $.ajax({
              url: `/calendar.js?category=${this.category}`,
              data: {
                start_date: view.intervalStart.format(),
                end_date: view.intervalEnd.format(),
              },
              success: () => {
                this.listView.next().fadeOut(300)
              },
            })
          }
        }

        this.calendar.next().fadeOut(300)
      },
      dayClick: (date) => {
        this.selectedDate = date
        this.singleDay.next().fadeIn(100)

        $.ajax({
          url: `/calendar/day_events.js?category=${
            this.category
          }&day=${date.format()}`,
          success: () => {
            this.singleDay.next().fadeOut(300)
          },
        })
      },
    })

    $('.fc-prev-button, .fc-next-button').on('click', (e) => {
      if ($('.events-calendar').hasClass('list-view')) {
        this.listView.next().fadeIn(100)
      } else {
        this.calendar.next().fadeIn(100)
      }
    })
  }

  viewChange(target) {
    $('#event-query').val('')

    if (!target.hasClass('active')) {
      this.viewToggle.removeClass('active')
      target.addClass('active')

      const targetView = target.data('view')

      $('.events-calendar').removeClass('event-results')

      if (targetView === 'list') {
        $('.events-calendar').addClass('list-view')
      } else {
        $('.events-calendar').removeClass('list-view')
      }

      this.showLoadingSpinners()

      this.selectedDate = this.calendar.fullCalendar('getDate')
      this.calendar.fullCalendar('changeView', targetView)
    }
  }

  showResults() {
    $('.events-calendar').removeClass('list-view')

    if (this.eventQuery) {
      $('.events-calendar').addClass('event-results')
      this.viewToggle.removeClass('active')
      this.calendar.fullCalendar('changeView', 'results')
    } else {
      this.viewChange($(".event-views__button[data-view='month']"))
    }

    $.ajax({
      url: `/calendar.js?category=${this.category}&query=${this.eventQuery}`,
      data: {
        start_date: moment().format(),
        end_date: moment().add(1, 'year').format(),
      },
      success: () => {
        this.eventResults.next().fadeOut(300)
      },
    })
  }

  showLoadingSpinners() {
    if ($('.events-calendar').hasClass('list-view')) {
      this.listView.next().fadeIn(100)
    } else if ($('.events-calendar').hasClass('event-results')) {
      this.eventResults.next().fadeIn(100)
    } else {
      this.singleDay.next().fadeIn(100)
    }
  }
}
